import { FormattedMessage } from 'react-intl';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import CircuitReport from '~/containers/CircuitReport';
import BranchOfficeReport from '~/containers/BranchOfficeReport';
import MonthlyReport from '~/containers/MonthlyReport';

import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useTheme } from '@mui/material';
import messages from './messages';

const TABS = {
  circuit: 'circuit',
  branch: 'branch',
  month: 'month',
};

const route = getRouteApi('/reports/$reportType');

export const Reports = () => {
  const { reportType } = route.useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <ContentView
      header={
        <div>
          <AppBar position="static" elevation={0}>
            <Toolbar>
              <DrawerButton />
              <Typography
                variant="h6"
                style={{ flexGrow: 1, marginLeft: theme.spacing(2) }}
                sx={{
                  color: 'inherit',
                }}
              >
                <FormattedMessage {...messages.header} />
              </Typography>
            </Toolbar>
          </AppBar>
          <AppBar position="static" elevation={0}>
            <Tabs
              indicatorColor="secondary"
              textColor="inherit"
              onChange={(event, tab) =>
                navigate({
                  to: '/reports/$reportType',
                  params: { reportType: tab },
                  search: {
                    year: undefined,
                    quarter: undefined,
                    month: undefined,
                  },
                })
              }
              value={reportType}
            >
              <Tab
                value={TABS.circuit}
                label={<FormattedMessage {...messages.circuitReport} />}
              />
              <Tab
                value={TABS.branch}
                label={<FormattedMessage {...messages.branchReport} />}
              />
              <Tab
                value={TABS.month}
                label={<FormattedMessage {...messages.monthReport} />}
              />
            </Tabs>
          </AppBar>
        </div>
      }
    >
      {reportType === TABS.circuit && <CircuitReport />}
      {reportType === TABS.branch && <BranchOfficeReport />}
      {reportType === TABS.month && <MonthlyReport />}
    </ContentView>
  );
};

export default Reports;
